var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "requisitions-applicants grid-x grid-padding-x grid-padding-y"
    },
    [
      _c("div", { staticClass: "cell medium-3" }, [
        _c("label", { staticClass: "filter-label" }, [
          _vm._v("Filter Applicants")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "search-box" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.searchTerm,
                expression: "searchTerm"
              }
            ],
            staticClass: "long-placeholder",
            attrs: {
              type: "text",
              placeholder: "Search candidate (name, surname, ID, etc.)"
            },
            domProps: { value: _vm.searchTerm },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.searchTerm = $event.target.value
                },
                _vm.handleInput
              ]
            }
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.searchTerm,
                expression: "searchTerm"
              }
            ],
            staticClass: "short-placeholder",
            attrs: { type: "text", placeholder: "Search candidate" },
            domProps: { value: _vm.searchTerm },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.searchTerm = $event.target.value
                },
                _vm.handleInput
              ]
            }
          }),
          _vm._v(" "),
          _c("i", { staticClass: "fa fa-solid fa-search icon" })
        ]),
        _vm._v(" "),
        _vm.showSpinner
          ? _c("div", { staticClass: "spinner" }, [
              _c("i", { staticClass: "fa fa-solid fa-spinner fa-spin" }),
              _vm._v(" Loading....\n        ")
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cell medium-9 top-margin" },
        _vm._l(_vm.allPhases, function(phase) {
          return _c("label", { key: phase.id, staticClass: "phase" }, [
            _c("div", { staticClass: "checkbox-group" }, [
              _vm._v(
                "\n                " +
                  _vm._s(
                    phase == "loading_cv"
                      ? "Loading CV"
                      : _vm.toTitleCase(phase)
                  ) +
                  "\n                "
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedPhases,
                    expression: "selectedPhases"
                  }
                ],
                attrs: { type: "checkbox" },
                domProps: {
                  value: phase,
                  checked: Array.isArray(_vm.selectedPhases)
                    ? _vm._i(_vm.selectedPhases, phase) > -1
                    : _vm.selectedPhases
                },
                on: {
                  change: [
                    function($event) {
                      var $$a = _vm.selectedPhases,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = phase,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.selectedPhases = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.selectedPhases = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.selectedPhases = $$c
                      }
                    },
                    _vm.phasesChanged
                  ]
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "check-mark" })
            ])
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "small-12 mb-2" }, [
        _c("div", { staticClass: "grid-x grid-padding-x grid-padding-y" }, [
          _vm.hasMore
            ? _c("div", { staticClass: "cell medium-1" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-success mycalling-green",
                    attrs: { disabled: _vm.showSpinner },
                    on: { click: _vm.loadMore }
                  },
                  [_vm._v("\n                    Load More\n                ")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "cell medium-2" }, [
            _c(
              "div",
              {
                staticClass: "grid-x grid-padding-x grid-padding-y align-middle"
              },
              [
                _c("div", { staticClass: "cell shrink" }, [
                  _vm._v("Bulk action: ")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cell auto" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.bulkAction,
                          expression: "bulkAction"
                        }
                      ],
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.bulkAction = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "" } }, [
                        _vm._v("Select")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "recycle" } }, [
                        _vm._v("Recycle")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "passed" } }, [
                        _vm._v("Passed")
                      ])
                    ]
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _vm.bulkAction == "recycle"
            ? _c(
                "div",
                { staticClass: "cell medium-3 recycle-info-container" },
                [
                  _c("div", [
                    _vm._v(
                      _vm._s(_vm.selectedApplications.length) + " selected"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button recycle px-5 ml-10",
                      attrs: {
                        disabled: _vm.selectedApplications.length <= 0,
                        type: "button"
                      },
                      on: {
                        click: function($event) {
                          return _vm.toggleModal("bulkRecycleModal")
                        }
                      }
                    },
                    [_vm._v("RECYCLE")]
                  )
                ]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "small-12" }, [
        _c("div", { staticClass: "table-responsive" }, [
          _c("table", { staticClass: "mb-4 table table-fixed" }, [
            _c("thead", [
              _c("tr", { staticClass: "table-head" }, [
                _vm.selectedPhases.includes("loading_cv")
                  ? _c("th", { staticClass: "border-head" }, [
                      _vm._v("\n                        Loading CV"),
                      _c("br"),
                      _vm._v(
                        "(" +
                          _vm._s(_vm.applicationsLoadingCv.length) +
                          " of " +
                          _vm._s(_vm.totalApplicationsLoadingCv) +
                          ")\n                        "
                      ),
                      _vm.bulkAction === "recycle"
                        ? _c("div", { staticClass: "select-all-in-phase" }, [
                            _c("input", {
                              attrs: {
                                type: "checkbox",
                                title: "Select all candidates"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.selectAllInPhase(
                                    "loading_cv",
                                    $event
                                  )
                                }
                              }
                            })
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedPhases.includes("killer_questions")
                  ? _c("th", { staticClass: "border-head" }, [
                      _vm._v("\n                        Killer Questions"),
                      _c("br"),
                      _vm._v(
                        "(" +
                          _vm._s(_vm.applicantsDoingKillerQuestions.length) +
                          " of " +
                          _vm._s(_vm.totalApplicantsDoingKillerQuestions) +
                          ")\n                        "
                      ),
                      _vm.bulkAction === "recycle"
                        ? _c("div", { staticClass: "select-all-in-phase" }, [
                            _c("input", {
                              attrs: {
                                type: "checkbox",
                                title: "Select all candidates"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.selectAllInPhase(
                                    "killer_questions",
                                    $event
                                  )
                                }
                              }
                            })
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedPhases.includes("language_proficiency")
                  ? _c("th", { staticClass: "border-head" }, [
                      _vm._v("\n                        Language Proficiency"),
                      _c("br"),
                      _vm._v(
                        "(" +
                          _vm._s(_vm.applicationsInLanguageProfPhase.length) +
                          " of " +
                          _vm._s(_vm.totalApplicationsInLanguageProfPhase) +
                          ")\n                        "
                      ),
                      _vm.bulkAction === "recycle"
                        ? _c("div", { staticClass: "select-all-in-phase" }, [
                            _c("input", {
                              attrs: {
                                type: "checkbox",
                                title: "Select all candidates"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.selectAllInPhase(
                                    "language_proficiency",
                                    $event
                                  )
                                }
                              }
                            })
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedPhases.includes("telephonic_screening")
                  ? _c("th", { staticClass: "border-head" }, [
                      _vm.atsType == "leadership_and_support"
                        ? _c("span", [_vm._v("Telephonic CV Screening")])
                        : _c("span", [_vm._v("Telephonic Screening")]),
                      _c("br"),
                      _vm._v(
                        "\n                        (" +
                          _vm._s(
                            _vm.applicantsInTelephonicScreeningPhase.length
                          ) +
                          " of " +
                          _vm._s(
                            _vm.totalApplicantsInTelephonicScreeningPhase
                          ) +
                          ")\n\n                        "
                      ),
                      _vm.bulkAction === "recycle"
                        ? _c("div", { staticClass: "select-all-in-phase" }, [
                            _c("input", {
                              attrs: {
                                type: "checkbox",
                                title: "Select all candidates"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.selectAllInPhase(
                                    "telephonic_screening",
                                    $event
                                  )
                                }
                              }
                            })
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedPhases.includes("first_interview")
                  ? _c("th", { staticClass: "border-head" }, [
                      _vm._v("\n                        First Interview"),
                      _c("br"),
                      _vm._v(
                        "(" +
                          _vm._s(_vm.applicantsInFirstInterviewPhase.length) +
                          " of " +
                          _vm._s(_vm.totalApplicantsInFirstInterviewPhase) +
                          ")\n\n                        "
                      ),
                      _vm.bulkAction === "recycle"
                        ? _c("div", { staticClass: "select-all-in-phase" }, [
                            _c("input", {
                              attrs: {
                                type: "checkbox",
                                title: "Select all candidates"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.selectAllInPhase(
                                    "first_interview",
                                    $event
                                  )
                                }
                              }
                            })
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedPhases.includes("background_verification") &&
                _vm.atsType == "leadership_and_support"
                  ? _c("th", { staticClass: "border-head" }, [
                      _vm._v(
                        "\n                        Background Verification"
                      ),
                      _c("br"),
                      _vm._v(
                        "(" +
                          _vm._s(
                            _vm.applicantsInBackgroundVerificationPhase.length
                          ) +
                          " of " +
                          _vm._s(
                            _vm.totalApplicantsInBackgroundVerificationPhase
                          ) +
                          ")\n\n                        "
                      ),
                      _vm.bulkAction === "recycle"
                        ? _c("div", { staticClass: "select-all-in-phase" }, [
                            _c("input", {
                              attrs: {
                                type: "checkbox",
                                title: "Select all candidates"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.selectAllInPhase(
                                    "background_verification",
                                    $event
                                  )
                                }
                              }
                            })
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedPhases.includes("skills_assessment")
                  ? _c("th", { staticClass: "border-head" }, [
                      _vm.atsType == "leadership_and_support"
                        ? _c("span", [_vm._v("Psychometric Assessment")])
                        : _c("span", [_vm._v("Skills Assessment")]),
                      _c("br"),
                      _vm._v(
                        "\n                        (" +
                          _vm._s(_vm.applicantsInSkillsAssessmentPhase.length) +
                          " of " +
                          _vm._s(_vm.totalApplicantsInSkillsAssessmentPhase) +
                          ")\n\n                        "
                      ),
                      _vm.bulkAction === "recycle"
                        ? _c("div", { staticClass: "select-all-in-phase" }, [
                            _c("input", {
                              attrs: {
                                type: "checkbox",
                                title: "Select all candidates"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.selectAllInPhase(
                                    "skill_assessment",
                                    $event
                                  )
                                }
                              }
                            })
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedPhases.includes("panel_interview")
                  ? _c("th", { staticClass: "border-head" }, [
                      _vm._v("\n                        Panel Interview"),
                      _c("br"),
                      _vm._v(
                        "(" +
                          _vm._s(_vm.applicantsInPanelInterviewPhase.length) +
                          " of " +
                          _vm._s(_vm.totalApplicantsInPanelInterviewPhase) +
                          ")\n\n                        "
                      ),
                      _vm.bulkAction === "recycle"
                        ? _c("div", { staticClass: "select-all-in-phase" }, [
                            _c("input", {
                              attrs: {
                                type: "checkbox",
                                title: "Select all candidates"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.selectAllInPhase(
                                    "panel_interview",
                                    $event
                                  )
                                }
                              }
                            })
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedPhases.includes("background_verification") &&
                _vm.atsType != "leadership_and_support"
                  ? _c("th", { staticClass: "border-head" }, [
                      _vm._v(
                        "\n                        Background Verification"
                      ),
                      _c("br"),
                      _vm._v(
                        "(" +
                          _vm._s(
                            _vm.applicantsInBackgroundVerificationPhase.length
                          ) +
                          " of " +
                          _vm._s(
                            _vm.totalApplicantsInBackgroundVerificationPhase
                          ) +
                          ")\n\n                        "
                      ),
                      _vm.bulkAction === "recycle"
                        ? _c("div", { staticClass: "select-all-in-phase" }, [
                            _c("input", {
                              attrs: {
                                type: "checkbox",
                                title: "Select all candidates"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.selectAllInPhase(
                                    "background_verification",
                                    $event
                                  )
                                }
                              }
                            })
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedPhases.includes("loading_offer")
                  ? _c(
                      "th",
                      { staticClass: "border-head" },
                      [
                        _vm.atsType === "leadership_and_support"
                          ? _c("span", [
                              _vm.requisition.is_pipeline
                                ? _c("span", [_vm._v("Passed Panel Interview")])
                                : _c("span", [_vm._v("Loading Offer")])
                            ])
                          : _c("span", [
                              _vm.requisition.is_pipeline
                                ? _c("span", [
                                    _vm._v("Passed Background Verification")
                                  ])
                                : _c("span", [_vm._v("Loading Offer")])
                            ]),
                        _vm._v(
                          "\n                        (" +
                            _vm._s(_vm.applicantsInLoadingOfferPhase.length) +
                            " of " +
                            _vm._s(_vm.totalApplicantsInLoadingOfferPhase) +
                            ")\n\n                        "
                        ),
                        _vm.bulkAction != ""
                          ? _c("div", { staticClass: "select-all-in-phase" }, [
                              _c("input", {
                                attrs: {
                                  type: "checkbox",
                                  title: "Select all candidates"
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.selectAllInPhase(
                                      "loading_offer",
                                      $event
                                    )
                                  }
                                }
                              })
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.selectedMoveApplications["loading_offer"].length >
                          0 && _vm.bulkAction == "passed"
                          ? _c("div", { staticClass: "selected-count" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-success mycalling-green w-100",
                                  on: {
                                    click: function($event) {
                                      return _vm.toggleModal(
                                        "passLoadingOfferModal"
                                      )
                                    }
                                  }
                                },
                                [_vm._v("Pass")]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("bulk-pass-modal", {
                          ref: "passLoadingOfferModal",
                          attrs: {
                            csrfToken: _vm.csrfToken,
                            "job-applications":
                              _vm.selectedMoveApplications["loading_offer"],
                            "phase-name": "Loading Offer",
                            phase: "loading_offer"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedPhases.includes("onboarding")
                  ? _c(
                      "th",
                      { staticClass: "border-head" },
                      [
                        _vm._v("\n                        Onboarding"),
                        _c("br"),
                        _vm._v(
                          "(" +
                            _vm._s(_vm.applicantsInOnboardingPhase.length) +
                            " of " +
                            _vm._s(_vm.totalApplicantsInOnboardingPhase) +
                            ")\n\n                        "
                        ),
                        _vm.bulkAction != ""
                          ? _c("div", { staticClass: "select-all-in-phase" }, [
                              _c("input", {
                                attrs: {
                                  type: "checkbox",
                                  title: "Select all candidates"
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.selectAllInPhase(
                                      "onboarding",
                                      $event
                                    )
                                  }
                                }
                              })
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.selectedMoveApplications["onboarding"].length > 0 &&
                        _vm.bulkAction == "passed"
                          ? _c("div", { staticClass: "selected-count" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-success mycalling-green w-100",
                                  on: {
                                    click: function($event) {
                                      return _vm.toggleModal(
                                        "passOnBoardingModal"
                                      )
                                    }
                                  }
                                },
                                [_vm._v("Pass")]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("bulk-pass-modal", {
                          ref: "passOnBoardingModal",
                          attrs: {
                            csrfToken: _vm.csrfToken,
                            "job-applications":
                              _vm.selectedMoveApplications["onboarding"],
                            "phase-name": "Onboarding",
                            phase: "onboarding"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedPhases.includes("start")
                  ? _c("th", { staticClass: "border-head" }, [
                      _vm._v("\n                        Start"),
                      _c("br"),
                      _vm._v(
                        "(" +
                          _vm._s(_vm.applicantsInStartPhase.length) +
                          " of " +
                          _vm._s(_vm.totalApplicantsInStartPhase) +
                          ")\n\n                        "
                      ),
                      _vm.bulkAction != ""
                        ? _c("div", { staticClass: "select-all-in-phase" }, [
                            _c("input", {
                              attrs: {
                                type: "checkbox",
                                title: "Select all candidates"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.selectAllInPhase("start", $event)
                                }
                              }
                            })
                          ])
                        : _vm._e()
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("tbody", [
              _c("tr", [
                _vm.selectedPhases.includes("loading_cv")
                  ? _c(
                      "td",
                      { staticClass: "align-top border-data" },
                      _vm._l(_vm.applicationsLoadingCv, function(
                        jobApplication
                      ) {
                        return _c("applicant-link", {
                          key: jobApplication.id,
                          attrs: {
                            "job-application": jobApplication,
                            requisition: _vm.requisition,
                            phase: "loading_cv",
                            "selected-applications":
                              _vm.selectedMoveApplications["loading_cv"],
                            "bulk-recycle": _vm.bulkAction
                          },
                          on: {
                            "update-selected-applications":
                              _vm.updateSelectedApplication
                          }
                        })
                      }),
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedPhases.includes("killer_questions")
                  ? _c(
                      "td",
                      { staticClass: "align-top border-data" },
                      _vm._l(_vm.applicantsDoingKillerQuestions, function(
                        jobApplication
                      ) {
                        return _c("applicant-link", {
                          key: jobApplication.id,
                          attrs: {
                            "job-application": jobApplication,
                            requisition: _vm.requisition,
                            phase: "killer_questions",
                            "selected-applications": _vm.selectedApplications,
                            "bulk-recycle": _vm.bulkAction
                          },
                          on: {
                            "update-selected-applications":
                              _vm.updateSelectedApplication
                          }
                        })
                      }),
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedPhases.includes("language_proficiency")
                  ? _c(
                      "td",
                      { staticClass: "align-top border-data" },
                      _vm._l(_vm.applicationsInLanguageProfPhase, function(
                        jobApplication
                      ) {
                        return _c("applicant-link", {
                          key: jobApplication.id,
                          attrs: {
                            "job-application": jobApplication,
                            requisition: _vm.requisition,
                            phase: "language_proficiency",
                            "selected-applications": _vm.selectedApplications,
                            "bulk-recycle": _vm.bulkAction
                          },
                          on: {
                            "update-selected-applications":
                              _vm.updateSelectedApplication
                          }
                        })
                      }),
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedPhases.includes("telephonic_screening")
                  ? _c(
                      "td",
                      { staticClass: "align-top border-data" },
                      _vm._l(_vm.applicantsInTelephonicScreeningPhase, function(
                        jobApplication
                      ) {
                        return _c("applicant-link", {
                          key: jobApplication.id,
                          attrs: {
                            "job-application": jobApplication,
                            requisition: _vm.requisition,
                            phase: "telephonic_screening",
                            "selected-applications": _vm.selectedApplications,
                            "bulk-recycle": _vm.bulkAction
                          },
                          on: {
                            "update-selected-applications":
                              _vm.updateSelectedApplication
                          }
                        })
                      }),
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedPhases.includes("first_interview")
                  ? _c(
                      "td",
                      { staticClass: "align-top border-data" },
                      _vm._l(_vm.applicantsInFirstInterviewPhase, function(
                        jobApplication
                      ) {
                        return _c("applicant-link", {
                          key: jobApplication.id,
                          attrs: {
                            "job-application": jobApplication,
                            requisition: _vm.requisition,
                            phase: "first_interview",
                            "selected-applications": _vm.selectedApplications,
                            "bulk-recycle": _vm.bulkAction
                          },
                          on: {
                            "update-selected-applications":
                              _vm.updateSelectedApplication
                          }
                        })
                      }),
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedPhases.includes("background_verification") &&
                _vm.atsType == "leadership_and_support"
                  ? _c(
                      "td",
                      { staticClass: "align-top border-data" },
                      _vm._l(
                        _vm.applicantsInBackgroundVerificationPhase,
                        function(jobApplication) {
                          return _c("applicant-link", {
                            key: jobApplication.id,
                            attrs: {
                              "job-application": jobApplication,
                              requisition: _vm.requisition,
                              phase: "background_verification",
                              "selected-applications": _vm.selectedApplications,
                              "bulk-recycle": _vm.bulkAction
                            },
                            on: {
                              "update-selected-applications":
                                _vm.updateSelectedApplication
                            }
                          })
                        }
                      ),
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedPhases.includes("skills_assessment")
                  ? _c(
                      "td",
                      { staticClass: "align-top border-data" },
                      _vm._l(_vm.applicantsInSkillsAssessmentPhase, function(
                        jobApplication
                      ) {
                        return _c("applicant-link", {
                          key: jobApplication.id,
                          attrs: {
                            "job-application": jobApplication,
                            requisition: _vm.requisition,
                            phase: "skills_assessment",
                            "selected-applications": _vm.selectedApplications,
                            "bulk-recycle": _vm.bulkAction
                          },
                          on: {
                            "update-selected-applications":
                              _vm.updateSelectedApplication
                          }
                        })
                      }),
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedPhases.includes("panel_interview")
                  ? _c(
                      "td",
                      { staticClass: "align-top border-data" },
                      _vm._l(_vm.applicantsInPanelInterviewPhase, function(
                        jobApplication
                      ) {
                        return _c("applicant-link", {
                          key: jobApplication.id,
                          attrs: {
                            "job-application": jobApplication,
                            requisition: _vm.requisition,
                            phase: "panel_interview",
                            "selected-applications": _vm.selectedApplications,
                            "bulk-recycle": _vm.bulkAction
                          },
                          on: {
                            "update-selected-applications":
                              _vm.updateSelectedApplication
                          }
                        })
                      }),
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedPhases.includes("background_verification") &&
                _vm.atsType != "leadership_and_support"
                  ? _c(
                      "td",
                      { staticClass: "align-top border-data" },
                      _vm._l(
                        _vm.applicantsInBackgroundVerificationPhase,
                        function(jobApplication) {
                          return _c("applicant-link", {
                            key: jobApplication.id,
                            attrs: {
                              "job-application": jobApplication,
                              requisition: _vm.requisition,
                              phase: "background_verification",
                              "selected-applications": _vm.selectedApplications,
                              "bulk-recycle": _vm.bulkAction
                            },
                            on: {
                              "update-selected-applications":
                                _vm.updateSelectedApplication
                            }
                          })
                        }
                      ),
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedPhases.includes("loading_offer")
                  ? _c(
                      "td",
                      { staticClass: "align-top border-data" },
                      _vm._l(_vm.applicantsInLoadingOfferPhase, function(
                        jobApplication
                      ) {
                        return _c("applicant-link", {
                          key: jobApplication.id,
                          attrs: {
                            "job-application": jobApplication,
                            requisition: _vm.requisition,
                            phase: "loading_offer",
                            "selected-applications": _vm.selectedApplications,
                            "bulk-recycle": _vm.bulkAction
                          },
                          on: {
                            "update-selected-applications":
                              _vm.updateSelectedApplication
                          }
                        })
                      }),
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedPhases.includes("onboarding")
                  ? _c(
                      "td",
                      { staticClass: "align-top border-data" },
                      _vm._l(_vm.applicantsInOnboardingPhase, function(
                        jobApplication
                      ) {
                        return _c("applicant-link", {
                          key: jobApplication.id,
                          attrs: {
                            "job-application": jobApplication,
                            requisition: _vm.requisition,
                            phase: "onboarding",
                            "selected-applications": _vm.selectedApplications,
                            "bulk-recycle": _vm.bulkAction
                          },
                          on: {
                            "update-selected-applications":
                              _vm.updateSelectedApplication
                          }
                        })
                      }),
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedPhases.includes("start")
                  ? _c(
                      "td",
                      { staticClass: "align-top border-data" },
                      _vm._l(_vm.applicantsInStartPhase, function(
                        jobApplication
                      ) {
                        return _c("applicant-link", {
                          key: jobApplication.id,
                          attrs: {
                            "job-application": jobApplication,
                            requisition: _vm.requisition,
                            phase: "start",
                            "selected-applications": _vm.selectedApplications,
                            "bulk-recycle":
                              _vm.bulkAction == "recycle" ? "recycle" : ""
                          },
                          on: {
                            "update-selected-applications":
                              _vm.updateSelectedApplication
                          }
                        })
                      }),
                      1
                    )
                  : _vm._e()
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.hasMore
          ? _c(
              "button",
              {
                staticClass: "btn btn-success mycalling-green",
                attrs: { disabled: _vm.showSpinner },
                on: { click: _vm.loadMore }
              },
              [_vm._v("\n            Load More\n        ")]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("bulk-recycle-modal", {
        ref: "bulkRecycleModal",
        attrs: {
          csrfToken: _vm.csrfToken,
          "job-applications": _vm.selectedApplications,
          "job-application": _vm.requisition
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bb1852be", { render: render, staticRenderFns: staticRenderFns })
  }
}